/* global gon */

function executeControllerAction () {
  const context = require.context('./javascripts', true, /\.js$/)
  const controller = gon.application?.controller

  if (controller) {
    const match = context.keys().find(key => key.endsWith(`/${controller}.js`))

    if (match) context(match)
  }

  const action = gon.application?.action
  let controllerAction

  try {
    // Require file appropriated for current controller (initialized in application.html)
    // Call method appropriated for current action (initialized in application.html)
    controllerAction = window[`${controller}#${action}`] // TODO: without window
  } catch (error) {
    console.error('Error loading controller action:', error)
  }

  if (controllerAction && typeof (controllerAction) === 'function') {
    controllerAction()
  }
}

document.addEventListener('turbo:render', executeControllerAction)
document.addEventListener('turbo:load', executeControllerAction)
